var map = {
	"./curaData_DatenPlattform.changed.png": 85259,
	"./curaData_DatenPlattform.png": 20370,
	"./curaData_FallstudieKantonAargau.png": 83309,
	"./curaData_FallstudieKantonAargau_Preview.png": 66826,
	"./curaData_Grafik_SpezAngebote.changed.png": 58345,
	"./curaData_Grafik_SpezAngebote.png": 75630,
	"./curaData_InfoGrafik_KantonZuerich_2050.chnaged.png": 77958,
	"./curaData_InfoGrafik_KantonZuerich_2050.png": 60215,
	"./curadata_Grafik_Newsroom_Pflegekraftmangel.png": 18059,
	"./curadata_Screenshot_Dashboard_Stionaer.changed.jpg": 72738,
	"./curadata_Screenshot_Dashboard_Stionaer.jpg": 79195,
	"./curadata_Screenshot_Szenarien.changed.jpg": 70588,
	"./curadata_Screenshot_Szenarien.jpg": 81097,
	"./curadata_Zukunftszenarien.png": 14454,
	"./curadata_oeffentliche_berichte.png": 49482,
	"./curadata_szenario_grundver_stat.png": 1110,
	"./medignition_logo.png": 95084,
	"./radioCircle.svg": 40145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;